import { settings } from '@pixi/core';
export { settings } from '@pixi/core';
settings.SORTABLE_CHILDREN = false;